import builder from '../builder';
import Add from '../../streamline-icons/light/add.svg';

export default builder('IconAddLight', Add);
